import * as React from "react";

import { cn } from "@/lib/utils";

export const Marquee = ({
  text,
  className,
  speed = 40,
}) => {
  return (
    <div className={cn("overflow-hidden", className)}>
      <div 
        style={{
          display: 'flex',
          overflow: 'hidden',
        }}
      >
        <div 
          style={{
            display: 'flex',
            gap: '4rem',
            animation: `marqueeScroll ${speed}s linear infinite`,
            willChange: 'transform',
          }}
        >
          <span style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>{text}</span>
          <span style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>{text}</span>
        </div>
      </div>
      
      <style>{`
        @keyframes marqueeScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};
